export default "__VITE_ASSET__d479c3e8__"